import { matchPath } from 'react-router-dom';
import { PAGE } from '@kioskgaming/ui';

export function getSuperAgentBreadcrumbTail(pathname: string): string[] {
  const is = (path: string) => matchPath({ path, end: true }, pathname) != null;
  if (is('/agents/new')) return [PAGE.agents, 'Create Agent'];
  if (is('/agents/:agentId')) return [PAGE.agents, 'Agent details'];
  if (is('/shops/:shopId')) return [PAGE.shops, 'Shop details'];
  if (is('/cash-transactions/:id')) return [PAGE.cashTransactions, 'Transaction details'];
  const top: Array<[string, string]> = [
    ['/', PAGE.dashboard],
    ['/agents', PAGE.agents],
    ['/shops', PAGE.shops],
    ['/players', PAGE.players],
    ['/transactions', PAGE.creditTransactions],
    ['/cash-transactions', PAGE.cashTransactions],
    ['/online-transactions', PAGE.usdWalletTransactions],
    ['/provider-fees', PAGE.feeConfiguration],
    ['/fraud-indicators', PAGE.fraudIndicators],
    ['/popups/send', PAGE.popups],
    ['/broadcasts/send', PAGE.broadcasts],
    ['/settings', PAGE.settings],
    ['/payment/return', PAGE.creditTransactions],
  ];
  const hit = top.find(([path]) => is(path));
  return hit ? [hit[1]] : [];
}
